<input [class.hidden]="!showResetButton" type="button" (click)="resetData()" value="" class="prf-reset-button" />
